import {pJS} from 'particles.js';

export default function eIndex(){
	const particles = document.getElementById('particles');
	const particlePath = '/dist/json/particlesjs-config.json'
	if(particles){
		particlesJS.load('particles', particlePath);
	}
}